import RecordsSummaryScreen from './RecordsSummaryScreen';

export default RecordsSummaryScreen;